import React from 'react'
import Layout from '../../components/layout/Layout'
import ReturnsTable from '../../elements/tables/returns/ReturnsTable'

export default function Returns() {
  return (
    <div>
      <Layout>
        <ReturnsTable />
      </Layout>
    </div>
  )
}
